"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Privacy() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.15
  });
  const {
    ref: prose1Ref,
    isVisible: prose1Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="6151" id="privacypolicy" className="bg-background py-24 md:py-36 text-foreground">
      <div className="mx-auto max-w-[1320px] px-5 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-12 md:gap-16 lg:grid-cols-12 lg:gap-12">
          {}
          <div className="lg:col-span-5">
            <div ref={imageRef} className="overflow-hidden rounded-lg shadow-lg" style={{
            opacity: imageVisible ? 1 : 0,
            transition: "opacity 1100ms ease-out"
          }}>
              <div className="relative w-full overflow-hidden bg-gradient-to-br from-blue-600 to-cyan-500" style={{
              aspectRatio: "4 / 5"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/cyber_security_data_protection.png" alt="Digital shield protecting sensitive business data" loading="lazy" decoding="async" className="h-full w-full object-cover opacity-80" style={{
                transform: imageVisible ? "scale(1)" : "scale(1.06)",
                transition: "transform 1100ms ease-out"
              }} />
              </div>
            </div>
            <p className="mt-4 font-default text-xs tracking-wide text-muted-foreground" style={{
            opacity: imageVisible ? 1 : 0,
            transform: imageVisible ? "translateY(0)" : "translateY(16px)",
            transition: "opacity 700ms cubic-bezier(0.22,1,0.36,1) 200ms, transform 700ms cubic-bezier(0.22,1,0.36,1) 200ms"
          }}>
              Data Privacy & Security Standards, 2026
            </p>
          </div>

          {}
          <div className="lg:col-span-7">
            <div ref={eyebrowRef} className="text-xs font-default font-medium uppercase tracking-[0.18em] text-blue-600" style={{
            opacity: eyebrowVisible ? 1 : 0,
            transform: eyebrowVisible ? "translateY(0)" : "translateY(16px)",
            transition: "opacity 700ms cubic-bezier(0.22,1,0.36,1), transform 700ms cubic-bezier(0.22,1,0.36,1)"
          }}>
              Our Commitment to Privacy
            </div>

            <h2 ref={headingRef} className="mt-6 font-default text-foreground" style={{
            fontSize: "clamp(2rem, 4vw, 3.5rem)",
            fontWeight: 700,
            letterSpacing: "-0.02em",
            lineHeight: 1.06,
            opacity: headingVisible ? 1 : 0,
            transform: headingVisible ? "translateY(0)" : "translateY(16px)",
            transition: "opacity 700ms cubic-bezier(0.22,1,0.36,1) 80ms, transform 700ms cubic-bezier(0.22,1,0.36,1) 80ms"
          }}>
              Protecting your <span className="text-blue-600">digital integrity</span>
            </h2>

            <div ref={prose1Ref} className="mt-12 grid grid-cols-1 gap-8 md:grid-cols-7 md:gap-10" style={{
            opacity: prose1Visible ? 1 : 0,
            transform: prose1Visible ? "translateY(0)" : "translateY(16px)",
            transition: "opacity 700ms cubic-bezier(0.22,1,0.36,1) 160ms, transform 700ms cubic-bezier(0.22,1,0.36,1) 160ms"
          }}>
              <p className="font-default text-muted-foreground md:col-span-4" style={{
              fontSize: "clamp(1.125rem, 1.5vw, 1.3125rem)",
              fontWeight: 400,
              letterSpacing: "-0.005em",
              lineHeight: 1.55,
              maxWidth: "42ch"
            }}>
                At InfinitySecure, your privacy is the foundation of our security architecture. We implement rigorous data protection protocols to ensure that your business intelligence remains confidential, secure, and fully compliant with global standards.
              </p>
              <p className="font-default text-muted-foreground md:col-span-3" style={{
              fontSize: "clamp(1.125rem, 1.5vw, 1.3125rem)",
              fontWeight: 400,
              letterSpacing: "-0.005em",
              lineHeight: 1.55,
              maxWidth: "42ch"
            }}>
                We believe that true security requires transparency. Our privacy policy outlines how we handle your data, ensuring you maintain complete control while we provide the AI-powered defense your organization requires.
              </p>
            </div>

            <div ref={ctaRef} className="mt-20" style={{
            opacity: ctaVisible ? 1 : 0,
            transform: ctaVisible ? "translateY(0)" : "translateY(16px)",
            transition: "opacity 700ms cubic-bezier(0.22,1,0.36,1) 240ms, transform 700ms cubic-bezier(0.22,1,0.36,1) 240ms"
          }}>
              <Button asChild variant="outline" size="lg" className="rounded-lg border-blue-600 bg-blue-600 px-7 py-3.5 text-white hover:bg-blue-700">
                <Link to="/ContactPage">Request a Free Security Assessment</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}